import { Table } from 'antd';
import { TbTruckDelivery } from 'react-icons/tb';

import ContractSection from './ContractSection';
import { getLength, getPrice, getWeightRange } from './helper';

/** B2B/B2C үнэ — тухайн төрөл гэрээнд байхгүй бол "-" */
const price = (enabled, value) => (enabled ? getPrice(value) : '-');

const columns = [
  {
    key: 'weight',
    title: 'Жин',
    render: (_, service) => getWeightRange(service.minWeight, service.maxWeight),
  },
  {
    key: 'totalLength',
    title: 'Нийлбэр урт (X+Y+Z)',
    align: 'right',
    render: (_, service) => getLength(service.totalLength),
  },
  {
    key: 'b2b',
    title: 'B2B',
    align: 'right',
    render: (_, service) => price(service?.isB2B, service.B2Bprice),
  },
  {
    key: 'b2c',
    title: 'B2C',
    align: 'right',
    render: (_, service) => price(service?.isB2C, service.B2Cprice),
  },
];

const Delivery = ({ services = [] }) => {
  const deliveryServices = services.filter((service) => service.serviceType === 'delivery');

  /** Жин/уртын завсрын үнэ бүхий мөрүүд */
  const rateServices = deliveryServices.filter((service) => service.type !== 'each');

  /** Нэгж тутмын нэмэлт төлбөр тусдаа үйлчилгээгээр ирдэг */
  const eachService = deliveryServices.find((service) => service.type === 'each');

  if (!rateServices.length) return null;

  const [first] = rateServices;

  const extraRow = (label, value) => (
    <Table.Summary.Row>
      <Table.Summary.Cell index={0} />
      <Table.Summary.Cell index={1} align="right">
        {label}
      </Table.Summary.Cell>
      <Table.Summary.Cell index={2} align="right">
        {price(first?.isB2B, value)}
      </Table.Summary.Cell>
      <Table.Summary.Cell index={3} align="right">
        {price(first?.isB2C, value)}
      </Table.Summary.Cell>
    </Table.Summary.Row>
  );

  return (
    <ContractSection
      icon={TbTruckDelivery}
      title="Хүргэлтийн төлбөр"
      description="Илгээмжийн жин, овор хэмжээнээс хамаарсан хүргэлтийн үнэ."
      columns={columns}
      dataSource={rateServices}
      summary={
        eachService
          ? () => (
              <>
                {extraRow('+1см тутамд', eachService.eachLength)}
                {extraRow('+1кг тутамд', eachService.eachWeight)}
              </>
            )
          : undefined
      }
    />
  );
};

export default Delivery;
